import { gql } from '@apollo/client';

import { SubjectFragment } from 'approot/shared/graphql/startup-data/startup-data.graphql';
import { assessmentEnglishContentAreaFragment } from '../content-areas/content-areas.graphql';
import { unitPlannerFragment } from 'approot/unit/unit.graphql';

const assessmentUnitFragment = gql`
  fragment AssessmentUnitFragment on Assessment {
    unit {
      id
      name
      slug
      unitStatus
      archivedAt
      subjects {
        ...SubjectFragment
      }
      topic {
        id
        label
        slug
      }
      lessons {
        id
        name
        slug
        sort
        outcomes {
          curriculum
        }
      }
      assessments {
        id
        name
        slug
        sort
        outcomes {
          curriculum
        }
      }
      ...UnitPlannerFragment
    }
  }
  ${unitPlannerFragment}
  ${SubjectFragment}
`;

export const assessmentPlannerFragment = gql`
  fragment AssessmentPlannerFragment on Assessment {
    id
    inPlanner {
      term
      added
      unitId
    }
  }
`;

export const assessmentIntegratedUnitFragment = gql`
  fragment AssessmentIntegratedUnitFragment on Assessment {
    integratedUnit {
      id
      name
      slug
      unitStatus
      archivedAt
      subjects {
        ...SubjectFragment
      }
      topic {
        id
        label
        slug
      }
      lessons {
        id
        name
        slug
        integratedSort
        outcomes {
          curriculum
        }
      }
      assessments {
        id
        name
        slug
        integratedSort
        outcomes {
          curriculum
        }
      }
      ...UnitPlannerFragment
    }
  }
  ${unitPlannerFragment}
  ${SubjectFragment}
`;

export const assessmentDetailsFragment = gql`
  fragment AssessmentDetailsFragment on Assessment {
    id
    name
    duration
    isAssigned
    authorId
    ...AssessmentUnitFragment
    ...AssessmentIntegratedUnitFragment
    ...AssessmentEnglishContentAreaFragment
    ...AssessmentPlannerFragment
    subjects {
      ...SubjectFragment
    }
    years {
      id
      name
      label
    }
  }
  ${assessmentUnitFragment}
  ${assessmentIntegratedUnitFragment}
  ${assessmentEnglishContentAreaFragment}
  ${assessmentPlannerFragment}
  ${SubjectFragment}
`;

export const UPDATE_ASSESSMENT_NAME = gql`
  mutation UpdateAssessmentName($input: UpdateAssessmentNameInput!) {
    updateAssessmentName(input: $input) {
      id
      name
    }
  }
`;

export const UPDATE_ASSESSMENT_DURATION = gql`
  mutation UpdateAssessmentDuration($input: UpdateAssessmentDurationInput!) {
    updateAssessmentDuration(input: $input) {
      id
      duration
    }
  }
`;

export const UPDATE_ASSESSMENT_SUBJECT = gql`
  mutation UpdateAssessmentSubjects($input: UpdateAssessmentSubjectsInput!) {
    updateAssessmentSubjects(input: $input) {
      id
      subjects {
        id
        name
        label
      }
      # clear outcomes
      outcomes {
        id
      }
      # clear performance expectations
      performanceExpectations {
        id
      }
    }
  }
`;

export const UPDATE_ASSESSMENT_YEARS = gql`
  mutation UpdateAssessmentYears($input: UpdateAssessmentYearsInput!) {
    updateAssessmentYears(input: $input) {
      id
      years {
        id
        name
        label
      }
      # clear outcomes
      outcomes {
        id
      }
      # clear performance expectations
      performanceExpectations {
        id
      }
    }
  }
`;

export const UPDATE_ASSESSMENT_UNIT = gql`
  mutation UpdateAssessmentUnit($input: UpdateAssessmentUnitInput!) {
    updateAssessmentUnit(input: $input) {
      id
      ...AssessmentUnitFragment
    }
  }
  ${assessmentUnitFragment}
`;

export const UPDATE_ASSESSMENT_INTEGRATED_UNIT = gql`
  mutation UpdateAssessmentIntegratedUnit(
    $input: UpdateAssessmentIntegratedUnitInput!
  ) {
    updateAssessmentIntegratedUnit(input: $input) {
      id
      ...AssessmentIntegratedUnitFragment
    }
  }
  ${assessmentIntegratedUnitFragment}
`;

export const REMOVE_ASSESSMENT_INTEGRATED_UNIT = gql`
  mutation RemoveAssessmentIntegratedUnit(
    $input: DeleteAssessmentIntegratedUnitInput!
  ) {
    deleteAssessmentIntegratedUnit(input: $input) {
      id
      ...AssessmentIntegratedUnitFragment
    }
  }
  ${assessmentIntegratedUnitFragment}
`;
